import React from 'react';
import css from './ContactUsForm.module.css';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import { InlineTextButton, PrimaryButton } from '../Button/Button';
import { BiHomeAlt } from 'react-icons/bi';
import Form from '../Form/Form';
import NamedLink from '../NamedLink/NamedLink';
import { FormattedMessage } from 'react-intl';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import FieldPhoneNumberInputWithDialCode from '../FieldPhoneNumberInputWithDialCode/FieldPhoneNumberInputWithDialCode';
import Thank_You_logo from '../../assets/svg/thankyou.svg';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
export default function ContactUsForm(props) {
  return (
    <React.Fragment>
      {props.step == 0 ? (
        <div className={css.ContactUsFormMain}>
          <div className={css.ContactUsFormDesc}>
            <h2 className={css.ContactUsFormDescHeading}>
              {' '}
              <FormattedMessage id="ContactUsForm.DescHeading" />
            </h2>
            <span className={css.ContactUsFormDescSubHeading}>
              <FormattedMessage id="ContactUsForm.DescSubHeading" />
            </span>
          </div>
          <div className={css.formcontainer}>
            <FinalForm
              {...props}
              render={fieldRenderProps => {
                const {
                  rootClassName,
                  className,
                  formId,
                  handleSubmit,
                  inProgress,
                  intl,
                  submitErr,
                  invalid,
                  form,
                  history,
                } = fieldRenderProps;
                const textfield = 'textfield';
                const errorTextField = 'errorTextField';
                const emailId = formId ? `${formId}.email` : 'email';
                const messageId = formId ? `${formId}.message` : 'message';
                const phoneNumberId = formId ? `${formId}.phoneNumber` : 'phoneNumber';

                const handleOnCancelBtnClick = () => {
                  history.replace(
                    createResourceLocatorString('LandingPage', routeConfiguration(), {})
                  );
                };

                // email
                const emailLabel = intl.formatMessage({
                  id: 'ContactUsForm.emailLabel',
                });
                const emailPlaceholder = intl.formatMessage({
                  id: 'ContactUsForm.emailPlaceholder',
                });
                const emailRequiredMessage = intl.formatMessage({
                  id: 'ContactUsForm.emailRequired',
                });
                const emailRequired = validators.required(emailRequiredMessage);
                const emailInvalidMessage = intl.formatMessage({
                  id: 'ContactUsForm.emailInvalid',
                });
                const emailValid = validators.emailFormatValid(emailInvalidMessage);

                const emailValidator = validators.composeValidators(emailRequired, emailValid);

                // phone number
                const phoneNumberLabel = intl.formatMessage({
                  id: 'ContactUsForm.phoneNumberLabel',
                });
                const phoneNumberPlaceholder = intl.formatMessage({
                  id: 'ContactUsForm.phoneNumberPlaceholder',
                });
                const phoneNumberRequiredMessage = intl.formatMessage({
                  id: 'ContactUsForm.phoneNumberRequired',
                });
                // const phoneNumberInvalidMessage = intl.formatMessage({
                //   id: 'ContactUsForm.phoneNumberInvalid',
                // });
                // const phoneNumberValid = validators.phoneNumberRequired(phoneNumberInvalidMessage)
                const phoneNumberRequired = validators.phoneNumberRequired(
                  phoneNumberRequiredMessage
                );
                const phoneNumberValidator = validators.composeValidators(phoneNumberRequired);

                // message
                const messageLabel = intl.formatMessage({
                  id: 'ContactUsForm.messageLabel',
                });
                const messagePlaceholder = intl.formatMessage({
                  id: 'ContactUsForm.messagePlaceholder',
                });
                const messageRequiredMessage = intl.formatMessage({
                  id: 'ContactUsForm.messageRequired',
                });
                const messageRequired = validators.required(messageRequiredMessage);

                const classes = classNames(rootClassName || css.root, className);
                const submitInProgress = inProgress;
                const submitDisabled = invalid || submitInProgress;

                return (
                  <Form className={classes} onSubmit={handleSubmit}>
                    <div className={css.formcontainer1}>
                      <div className={css.field}>
                        <FieldTextInput
                          className={textfield}
                          errorClassName={errorTextField}
                          type="email"
                          id={emailId}
                          name="email"
                          autoComplete="email"
                          label={emailLabel}
                          placeholder={emailPlaceholder}
                          validate={emailValidator}
                        />
                      </div>
                      <div className={css.field}>
                        <FieldPhoneNumberInputWithDialCode
                          name="phoneNumber"
                          id={phoneNumberId}
                          label={phoneNumberLabel}
                          placeholder={phoneNumberPlaceholder}
                          validate={phoneNumberValidator}
                          className={textfield}
                          errorClassName={errorTextField}
                        />
                      </div>
                    </div>
                    <div className={css.formcontainer2}>
                      <FieldTextInput
                        className={textfield}
                        type="textarea"
                        name="message"
                        autoComplete="message"
                        id={messageId}
                        label={messageLabel}
                        validate={messageRequired}
                        placeholder={messagePlaceholder}
                      />
                    </div>
                    <div className={css.bottoncontainer}>
                      {!!submitErr && (
                        <p className={css.error}>{<FormattedMessage id={submitErr} />}</p>
                      )}
                      <PrimaryButton
                        className={css.submitBtn1}
                        type="submit"
                        inProgress={submitInProgress}
                        disabled={submitDisabled}
                      >
                        <FormattedMessage id="ContactUsForm.signUp" />
                      </PrimaryButton>
                      <InlineTextButton
                        type="button"
                        className={css.cancelBtn}
                        onClick={handleOnCancelBtnClick}
                      >
                        <FormattedMessage id="SignupForm.signUpCancel" />
                      </InlineTextButton>
                    </div>
                  </Form>
                );
              }}
            />
          </div>
        </div>
      ) : (
        <div className={css.ContactUsFormThankYouMain}>
          <div className={css.ThankYouWrapper}>
            <img src={Thank_You_logo} alt="" />
            <span className={css.ContactUsFormThankYouSpan1}>
              {' '}
              <FormattedMessage id="ContactUsForm.ThankYouSpan1" />{' '}
            </span>
            <span className={css.ContactUsFormThankYouSpan2}>
              {' '}
              <FormattedMessage id="ContactUsForm.ThankYouSpan2" />
            </span>
          </div>
          <NamedLink name="LandingPage">
            <div className={css.GotoHomeWrapper}>
              <BiHomeAlt className={css.homeicon} />
              <span className={css.GotoHomeSpan}>
                <FormattedMessage id="ContactUsForm.GotoHomeSpan" />
              </span>
            </div>
          </NamedLink>
        </div>
      )}
    </React.Fragment>
  );
}
